/**
 * disc-performance.js
 * Behavior for the Disc Performance section's cards:
 *   1. Read more: for each [data-dp-readmore] block, clamp the description
 *      to its configured number of lines, check whether the text really
 *      overflows, and only then show the "Read more" button (a short
 *      description shows in full with no button).
 *   2. Popup: the button opens the shared site popup (assets/sdg-dialog.js,
 *      [data-sdg-open]) containing the full text.
 * No dependencies. Safe to load more than once (guarded by a flag).
 */
(function () {
  if (window.__sdgDiscPerformance) return;
  window.__sdgDiscPerformance = true;

  function measure(block) {
    var text = block.querySelector('.dp-readmore__text');
    var button = block.querySelector('.dp-readmore__button');
    if (!text || !button) return;

    // Measure with the clamp on, then decide whether to keep it.
    text.classList.add('is-clamped');
    var overflows = text.scrollHeight > text.clientHeight + 2;
    if (overflows) {
      button.hidden = false;
    } else {
      text.classList.remove('is-clamped');
      button.hidden = true;
    }
  }

  function measureAll(root) {
    (root || document).querySelectorAll('[data-dp-readmore]').forEach(measure);
  }

  function init() {
    measureAll();
    // Re-measure once web fonts are in (line widths change) and on resize.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measureAll(); });
    var timer;
    window.addEventListener('resize', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        // Un-clamp first so a card that grew wider can drop the button.
        document.querySelectorAll('[data-dp-readmore] .dp-readmore__text').forEach(function (t) {
          t.classList.remove('is-clamped');
        });
        measureAll();
      }, 150);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: section re-rendered.
  document.addEventListener('shopify:section:load', function (event) { measureAll(event.target); });
})();
